<template>
<div>
    <el-dialog :title="title" class="c-dialog-fixed" width="700px" :visible.sync="show" :append-to-body="inDialog" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" center top="5vh" @open="openDialog" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="mini" status-icon class="c-form-mini">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="国家:" prop="country">
                        <el-select v-model="form.country" placeholder="请选择国家" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option  @change="handleChange">
                            <el-option v-for="item in countrylist" :key="item.id" :label="item.title" :value="item.title" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="一级地区:" prop="region">
                        <el-select v-model="form.region" placeholder="选择一级地区" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option  @change="handleChange2">
                            <el-option v-for="item in regionlist" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="二级地区:" prop="region2">
                        <el-select v-model="form.region2" placeholder="选择二级地区" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in region2list" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="中文名称:" prop="chinese">
                        <el-input v-model="form.chinese" type="primary" style="width: 200px" placeholder="请输入" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="其它语言名称:" prop="english">
                        <el-input v-model="form.english" type="primary" style="width: 200px" placeholder="请输入名称" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="语言:" prop="language">
                        <el-select v-model="form.language" placeholder="请输入或选择语言" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in languageOption" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>

                <el-col :span="12">
                    <el-form-item label="宗教:" prop="religion">
                        <el-select v-model="form.religion" placeholder="请选择宗教" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in religionlist" :key="item" :label="item" :value="item" />
                        </el-select>

                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="派别:" prop="party">
                        <el-select v-model="form.party" placeholder="填入或选择派别" class="filter-item" style="width: 200px;" filterable allow-create clearable>
                            <el-option v-for="item in partyOption" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="经营性质:" prop="type">
                        <el-select v-model="form.type" placeholder="请选择经营性质" class="filter-item" style="width: 200px;" filterable clearable allow-create default-first-option>
                            <el-option v-for="item in typelist" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="隶属" prop="relation">
                        <el-input v-model="form.relation" type="primary" style="width: 200px" placeholder="请输入从属关系" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="谷歌地图链接:" prop="google">
                        <el-input v-model="form.google" type="primary" style="width: 200px" placeholder="请输入链接" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="地址:" prop="address">
                        <el-input v-model="form.address" type="primary" style="width: 200px" placeholder="请输入地址" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="电话:" prop="tel">
                        <el-input v-model="form.tel" type="primary" style="width: 200px" placeholder="请输入电话" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱:" prop="email">
                        <el-input v-model="form.email" type="primary" style="width: 200px" placeholder="请输入邮箱" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="网站:" prop="url">
                        <el-input v-model="form.url" type="primary" style="width: 200px" placeholder="请输入网站" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="其它联系方式" prop="contact">
                        <el-input v-model="form.contact" type="primary" style="width: 200px" placeholder="请输入其它联系方式" />
                    </el-form-item>
                </el-col>

            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="营业时间" prop="businesshours">
                        <el-input v-model="form.businesshours" type="primary" style="width: 200px" placeholder="请输入营业时间" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="接洽人：" prop="person">
                        <el-input v-model="form.person" type="primary" style="width: 200px" placeholder="请输入接洽人：" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="接洽人联系方式：" prop="link">
                        <el-input v-model="form.link" type="primary" style="width: 200px" placeholder="请输入联系方式：" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="拜访次数：" prop="count">
                        <el-input v-model="form.count" type="primary" style="width: 200px" placeholder="请输入拜访次数：" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>

                 <el-row>
                     <el-col :span="12">
                         <el-form-item label="审核状态:" prop="party">
                        <el-select v-model="form.status" placeholder="选择审核状态" class="filter-item" style="width: 200px;" filterable allow-create clearable>
                            <el-option v-for="item in statuslist" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col> 

                </el-row>

                <el-col :span="12">
                    <el-form-item label="备注:" prop="remark">
                        <!-- <el-input v-model="form.remark" type="primary" style="width: 200px" placeholder="请输入备注" /> -->
                         <textarea v-model="form.remark" style="width: 400px;height: 200px" placeholder="请输入内容..."></textarea>
                    </el-form-item>
                </el-col>
                       
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false">
                取消
            </el-button>
            <el-button type="primary" @click="title === '添加记录' ? addData() : editData()">
                确认
            </el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
// import waves from '@/directive/waves'
import {
    entity_list_page,
    country_list_all,
    entity_list_all,
    entity_list_getReligion,
    entity_list_getLanguage,
    entity_list_getParty,
    entity_list_getRegion,
    entity_list_getType,
    entity_add,
    entity_edit,
    region_list_getRegionByCountry,
    region_list_getRegion2ByRegion
} from '../../api';

const formInit = {
    country: '', //国家
    region: '', //一级地区
    region2: '', //二级地区
    chinese: '', //中文名称
    english: '', //英文名
    language: '', //语言
    religion: '', //宗教
    party: '', //派别
    type: '', //种类
    relation: '', //从属关系隶属于
    google: '', //谷歌地址链接
    address: '', //地址
    tel: '', //电话
    email: '', //邮箱
    url: '', //网站
    contact: '', //其他联系方式
    businesshours: '', //营业时间

    person: '', //接洽人
    link: '', // 接洽人的联系方式
    count: '', // 联系次数
    remark: '', //备注
}
export default {
    name: 'AddDetail',
    // directives: { waves },
    components: {

    },
    props: {
        module: {
            type: String,
            default: ''
        },
        inDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '新增',
            areaChildLocation: [],
            countrylist: [],
            projectTypeOnes: [],
            loading: false,
            form: {
                ...formInit
            },
            isPublicOption: [],
            partyOption: [],
            languageOption: [],
            religionlist: [],
            regionlist: [],
            region2list: [],
            statusOption: [

            ],
            typelist: [],
            contypeOption: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }

            ],
                statuslist: [
                {
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            show: false,
            updated: false,
            nowUser: '',

            lander: {},
            file: {},
            query: {},

            rules: {
                itemcode: [{
                    required: true,
                    pattern: /^\d{13}$/,
                    message: '请输入13位纯数字物料编码',
                    trigger: ''
                }],

            }
        }
    },
    created() {
        this.getItems()
    },
    mounted() {
        this.nowUser = localStorage.getItem('account')
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.getItems();
        this.getCountry();
    },
    methods: {

        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            country_list_all(this.query).then((res) => {
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },

        openDialog() {
            this.$nextTick(() => {
                if (this.resolve) {
                    this.resolve(this)
                }
            })
        },
        open() {
            this.show = true
            this.getCountry()
            return new Promise((resolve, reject) => {
                this.resolve = resolve
            })
        },
        clearValidate() {
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate()
            })
        },
        resetFields() {
            this.updated = false
            this.form = {
                ...formInit
            }
            this.clearValidate()
            return this
        },
        closeDialog() {
            const vm = this
            vm.form = {
                ...formInit
            }
            this.resetFields()
        }, // 关闭弹窗操作
        update() {
            this.loading = false
            this.updated = true
            this.show = false
            this.$emit('addRefresh')
            this.resetFields()
        },

        updateForEdit() {
            this.$parent.$emit('addRefresh')
            this.loading = false
            this.updated = true
            this.show = false
            this.resetFields()
        },
        initData(data, title) {
            if (title == 'add') {
                this.title = "添加记录"
            } else {
                this.title = "编辑数据"
            }
            this.assign(data)
            this.clearValidate()
        },
        assign(data) {
            this.form = {
                ...this.form,
                ...data
            }
            return this
        },
         handleChange() {
            this.regionlist = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.query.country = this.form.country
            region_list_getRegionByCountry(this.query).then((response) => {
                this.regionlist = response.data.obj
            })
        },
          handleChange2() {
            this.region2list = null;
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.query.region = this.form.region
            region_list_getRegion2ByRegion(this.query).then((response) => {
                this.region2list = response.data.obj
            })
        },
        addData() {
            this.$refs['form'].validate(() => {
                this.form.uid = this.lander.uid;
                this.form.token = this.lander.token;
                entity_add(this.form).then((res) => {
                    this.$notify({
                        title: '成功',
                        message: '编辑成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.update()
                })

            })
        },
        editData() {

            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.uid = this.lander.uid;
                    this.form.token = this.lander.token;

                    entity_edit(this.form).then((res) => {
                        console.log("22jia");
                        console.log(this.form);

                        this.$notify({
                            title: '成功',
                            message: '编辑成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.update()
                    })
                }
            })
        },
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            entity_list_getReligion(this.query).then((res) => {
                this.religionlist = res.data.obj
            })
            entity_list_getLanguage(this.query).then((res) => {
                this.languageOption = res.data.obj
            })
            entity_list_getParty(this.query).then((res) => {
                this.partyOption = res.data.obj
            })
            entity_list_getRegion(this.query).then((res) => {
                this.regionlist = res.data.obj
            })
            entity_list_getType(this.query).then((res) => {
                this.typelist = res.data.obj
            })
        }

    }
}
</script>

<style lang="scss" scoped>
</style>
